import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class ProgramService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.PROGRAMS(), data);
    }

    getByAdmin(id, data): Observable<any> {
        return this.getRequest(AppUrl.PROGRAMS(id), data);
    }

    getByLanding(id, data): Observable<any> {
        return this.getRequest(AppUrl.PROGRAMS(id), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.PROGRAMS_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.PROGRAMS(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.PROGRAMS(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.PROGRAMS(id), data);
    }

    updatePassword(id, data): Observable<any> {
        return this.putRequest(AppUrl.PROGRAMS_PASSWORD(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.PROGRAMS_STATUS(id), data);
    }
}
